import { render } from "./Notes18.vue?vue&type=template&id=538a5456&scoped=true"
import script from "./Notes18.vue?vue&type=script&lang=js"
export * from "./Notes18.vue?vue&type=script&lang=js"

import "./Notes18.vue?vue&type=style&index=0&id=538a5456&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538a5456"]])

export default __exports__